
        import 'Card.7564aaf.css-module'
        export default {"Card":"Card_Card_7564aaf","highlight":"highlight_Card_7564aaf"}
    